import styled from 'styled-components';

export const GridTemplate = styled.div.attrs(({ typeView }) => (
  {
    style: {
      display: 'grid',
      gridAutoRows: 'min-content',
      gridTemplateColumns: typeView ? '3fr 3fr 0.5fr 0.5fr 0.5fr' : '3fr 1.75fr 0.25fr 0.5fr 0.5fr 0.5fr',
      gridTemplateAreas: typeView
        ? `"payer  payment_notes order_amount revenue_amount warning"
              "contract payment_notes order_amount revenue_amount payment_number"`
        : `"payer contract payment_number order_amount revenue_amount warning"
                   "payment_notes payment_notes payment_notes payment_notes payment_notes payment_notes"`
      ,
    },

  }
))`
`;

export const DivElement = styled.div`
  border: 1px solid #DDE2E9; 
  padding: .15em 9px;
  position: relative;
  &:hover{
    background: linear-gradient(0deg, #66BC7A, #66BC7A), #008F21
  };
`;

export const DivHeader = styled.div`
  border: 1px solid #DDE2E9; 
  grid-area: ${({ area }) => area};
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: 0;
  //height: 2.3em;
  z-index: 1;
  padding: .25em 9px;
  background: linear-gradient(0deg,rgba(255,255,255,0.88),rgba(255,255,255,0.88)),#4281C9;
  cursor: pointer;
  font-family: Roboto,sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: black;
`;
